import dayjs from 'dayjs';
import { List, ListItemButton } from '@mui/material';
import SubjectIcon from '../Marks/SubjectIcon/SubjectIcon';
import MarkIcon from '../Marks/MarkIcon/MarkIcon';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

function getGodina(datum) {
  if (!datum) return '';
  return dayjs(datum).format('YYYY');
}

export default function ExtTest({ marks = [] }) {
  return (
    <div>
      <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {marks.map((mark, index) => (
                <ListItemButton key={index} sx={{ p: 0, m: 0 }}>
                  <div className="main-flex-container">
                    <SubjectIcon naziv={mark.naziv_predmeta} id={mark.id_grupe} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{mark.naziv_predmeta}</div>
                      </div>
                      <div className="bottom-flex-container">
                        <div className="centered-container"><MarkIcon mark={mark.ocjena} /></div>
                        <div className="centered-container">{mark.naziv_tipa}</div>
                      </div>
                    </div>
                    <div className="date-container">
                      <div>{getDan(mark.datum_upisivanja)}</div>
                      <div>{getMjesec(mark.datum_upisivanja)}</div>
                      <div>{getGodina(mark.datum_upisivanja)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
      </div>
    </div>
  );
}
